import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Alert, TextField,
} from "@mui/material";
import axios from "../../../config/axiosConfig";

const AgregarCantidadDialog = ({ open, onClose, producto, sucursal, onAgregado }) => {
  const [cantidad, setCantidad] = useState("");
  const [detalle, setDetalle] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setCantidad("");
      setDetalle("");
      setError("");
    }
  }, [open]);

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.post("/api/inventario-interno/registro", {
        id_producto: producto.id,
        sucursal,
        cantidad: Number(cantidad),
        detalle: detalle.trim(),
      });
      onAgregado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al registrar la cantidad.");
    } finally {
      setSaving(false);
    }
  };

  const puedeGuardar = Number(cantidad) > 0 && detalle.trim() && !saving;

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>
        Agregar cantidad — {producto?.nombre} ({sucursal})
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5} sx={{ mt: 0.5 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            size="small" type="number" label="Cantidad a agregar" required
            value={cantidad} onChange={(e) => setCantidad(e.target.value)}
            inputProps={{ min: 1, step: 1 }}
          />
          <TextField
            size="small" label="Detalle" multiline minRows={2} required
            value={detalle} onChange={(e) => setDetalle(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar}>
          {saving ? "Guardando..." : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgregarCantidadDialog;
